import { render, staticRenderFns } from "./TopBrandSalesChart.vue?vue&type=template&id=910880b4&scoped=true"
import script from "./TopBrandSalesChart.vue?vue&type=script&lang=js"
export * from "./TopBrandSalesChart.vue?vue&type=script&lang=js"
import style0 from "./TopBrandSalesChart.vue?vue&type=style&index=0&id=910880b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910880b4",
  null
  
)

export default component.exports